<div id="appLoadingScreen">
  <div id="appLoadingSpinner"></div>
</div>
